// @ts-ignore
import './ReporterListPage.scss';
import { useState, useEffect, useMemo } from 'react';
import { useApiClient } from '../../hooks/useApiClient';
import TableContainer from '../../components/genericTable/TableContainer';
import { columnsData } from './columnsData';
import toaster from '../../utils/toaster';
import { useTranslation } from 'react-i18next';
import i18next from 'i18next';
import _ from 'lodash';
import { Container, Row, Col } from 'react-bootstrap';
import Btn from '../../components/Btn/Btn';
import { FaPlus } from 'react-icons/fa';
import { Link, useNavigate } from 'react-router-dom';
import { GTMsendEvent } from '../../utils/trackingGA4';
import { RoleEnum, UserDTO } from 'src/api';
import { useAuth } from 'src/hooks/useAuth';
import { BsEye } from 'react-icons/bs';

const ReporterListPage = () => {
	const { apiClient, handleApi } = useApiClient();
	const [response, setResponse] = useState<UserDTO[] | null>(null);
	const [loading, setLoading] = useState(true);
	const [error, setError] = useState(null);
	const { userRole } = useAuth();
	const { t } = useTranslation();

	const navigate = useNavigate();

	useEffect(() => {
		handleApi(apiClient.userController.getRegisterUsersSegnalatore())
			.then((res) => {
				setResponse(res);
				setLoading(false);
			})
			.catch((err) => {
				setError(err);
				setLoading(false);
				toaster.error(
					err.message || i18next.t('users_list') // Errore non specificato durante il caricamento dati
				);
			});
	}, []);

	const isAllowed = [RoleEnum.SALES_DEALER].includes(userRole);

	const columns = useMemo(() => {
		if (isAllowed) {
			const columns = columnsData.map((c) => {
				if (c.id === 'actions') {
					c.Cell = (data: any) => (
						<div className="d-flex">
							<Link
								to={`/my-reporters/details/${data.row.original.username}`}
								className="btn"
								onClick={() => {
									GTMsendEvent({
										event: 'CTA_modify_user',
										evtCat: 'user',
										evtAct: 'modify',
										evtLab: `modify_user`,
									});
								}}
							>
								<BsEye
									style={{ width: '1.2rem', height: '1.6rem' }}
									name="view"
								/>
							</Link>
						</div>
					);
				}

				return c;
			});

			return columns;
		}

		return (columnsData || []).filter((item) => item.id !== 'actions');
	}, [userRole]);

	const data = useMemo(() => {
		// @ts-ignore
		const items = (response || []).sort((a, b) => new Date(b.created_date) - new Date(a.created_date));

		return items.sort((x, y) => {
			const hasAlertX = !_.isEmpty(x?.alert);
			const hasAlertY = !_.isEmpty(y?.alert);

			if (hasAlertX && !hasAlertY) return -1;
			if (!hasAlertX && hasAlertY) return 1;
			return 0;
		});

		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [response]);

	return (
		<Container fluid>
			<Row>
				<Col md={6} className="display-6">
					{t('my_reporters')}
				</Col>

				<Col md={6} className="mt-4 mt-md-0 text-md-end">
					<Btn
						onClick={() => {
							navigate(`/my-reporters/new?role=${RoleEnum.SEGNALATORE}`);
							GTMsendEvent({
								event: 'CTA_create_new_reporter',
								evtCat: 'reporter',
								evtAct: 'create',
								evtLab: 'new_reporter',
							});
						}}
					>
						<FaPlus />
						{t('create_new_reporter')}
					</Btn>
				</Col>
			</Row>

			<TableContainer
				dblClickCallback={(row: any) => {
					if (!isAllowed) {
						return;
					}
					navigate(`/my-reporters/details/${row.username}`);
				}}
				columns={columns}
				data={data}
				loading={loading}
				error={error}
			></TableContainer>
		</Container>
	);
};

export default ReporterListPage;
